import {cloneDeep} from 'lodash-es'
import { url2localProtocol } from '@/common/utils/util'
/**
 * 关于接口图片字段的结构化
 * @param  {Array}  urls 图片url
 * @param  {Object} keys 上传图片时返回的key
 * @return {[type]}      结构化后数据，便于组件使用
 */
export function picDataFormat (urls, keys) {
  if (!urls) {
    urls = []
  }
  if (!keys) {
    keys = []
  }
  urls = urls.filter(item => item)
  return urls.map((item, index) => {
    return {
      customUrl: item,
      url: url2localProtocol(item),
      key: keys[index] || '',
      name: keys[index] || ''
    }
  })
}

// 处理图片列表数据
export function formatPics (data) {
  if (data && typeof data === 'object' && data.keys && data.keys.length && data.urls && data.urls.length) {
    return picDataFormat(data.urls, data.keys)
  }
  return []
}

// 处理时间
export function formatDate (date) {
  if (!date) return null
  return new Date(date)
}

// 处理配送方式字段
export function formatDelivery (data = {}) {
  data.oneselfType = 2
  data.platformType = 2
  if (data.deliveryType && (data.deliveryType === 2 || data.deliveryType === 3)) {
    data.oneselfType = 1
    data.oneselfRate = data.commissionJson.onself
  }
  if (data.deliveryType && (data.deliveryType === 1 || data.deliveryType === 3)) {
    data.platformType = 1
    data.platformRate = data.commissionJson.platform
  }
  return data
}
// 处理授权书数据
export function formatAuthorization (data = {}) {
  return ['sign', 'payment'].reduce((pre, key) => {
    if (!data[key]) {
      pre[key] = {}
      return pre
    }
    pre[key] = {
      ...data[key],
      authorizedPics: formatPics(data[key].authorizedPics),
      extraPics: formatPics(data[key].extraPics),
      pics: formatPics(data[key].pics)
    }
    return pre
  }, {})
}

// 签约主体基础信息处理
export function formatPartyBasic (data = {}) {
  if (data.frontPhoto) {
    data.frontPhoto = picDataFormat([data.frontPhoto], [data.frontPhoto])
  }
  if (data.logo) {
    data.logo = picDataFormat([data.logo], [data.logo])
  }
  if (data.environmentalPhoto && typeof data.environmentalPhoto === 'object' && data.environmentalPhoto.length) {
    data.environmentalPhoto = picDataFormat(data.environmentalPhoto, data.environmentalPhoto)
  }
  return data
}

// 处理资质信息
export function formatQualification (data = {}) {
  if (data.city) {
    data.city.validateDate = formatDate(data.city.validateDate)
    data.city.licensePics = formatPics(data.city.licensePics)
    data.city.files = formatPics(data.city.files)
    data.city.openDate = data.city.openDate && typeof data.city.openDate === 'object' ? data.city.openDate : {}
  }
  if (data.health) {
    data.health.validateDate = formatDate(data.health.validateDate)
    data.health.licensePics = formatPics(data.health.licensePics)
    data.health.files = formatPics(data.health.files)
  }
  if (data.land) {
    data.land.validateDate = formatDate(data.land.validateDate)
    data.land.licensePics = formatPics(data.land.licensePics)
    data.land.files = formatPics(data.land.files)
  }
  if (data.sell) {
    data.sell.licensePics = formatPics(data.sell.licensePics)
    data.sell.files = formatPics(data.sell.files)
    data.sell.openDate = data.sell.openDate && typeof data.sell.openDate === 'object' ? data.sell.openDate : {}
  }
  if (data.corp) {
    data.corp.notaryDate = formatDate(data.corp.notaryDate)
    data.corp.licensePics = formatPics(data.corp.licensePics)
    data.corp.files = formatPics(data.corp.files)
  }
  if (data.esc) {
    data.esc.checkDate = formatDate(data.esc.checkDate)
    data.esc.licensePics = formatPics(data.esc.licensePics)
    data.esc.files = formatPics(data.esc.files)
  }
  return data
}
// 处理合同信息
export function formatContrat (data = {}, shopData = {}) {
  data.legalPics = formatPics(data.legalPics)
  data.legalExtra = formatPics(data.legalExtra)
  data.taxPics = formatPics(data.taxPics)
  // copy银行卡号用于二次确认
  data.backupAccountCardno = data.accountCardno
  data.authorizationInfo = formatAuthorization(data.authorizationInfo)
  data.shopAuthorizationInfo = formatAuthorization(shopData.authorizationInfo)
  return formatDelivery(data)
}
// 处理其他信息
export function formatOtherExtra (data = {}, shopData = {}) {
  if (!data) {
    data = {}
  }
  if (data.bankFlow) {
    data.bankFlow.pics = formatPics(data.bankFlow.pics)
    data.bankFlow.files = formatPics(data.bankFlow.files)
  } else {
    data.bankFlow = {}
  }
  if (data.other) {
    data.other.pics = formatPics(data.other.pics)
    data.other.files = formatPics(data.other.files)
  } else {
    data.other = {}
  }
  return data
}

export function formatShopBasic (data = {}) {
  if (data.logo) {
    data.logo = picDataFormat([data.logo], [data.logo])
  }
  if (data.frontPhoto && typeof data.frontPhoto === 'object' && data.frontPhoto.length) {
    data.frontPhoto = picDataFormat(data.frontPhoto, data.frontPhoto)
  }
  if (data.environmentalPhoto && typeof data.environmentalPhoto === 'object' && data.environmentalPhoto.length) {
    data.environmentalPhoto = picDataFormat(data.environmentalPhoto, data.environmentalPhoto)
  }
  return data
}

/**
 * 根据配置筛选结构化数据
 * @param  {[type]} paramsKeys 参数配置
 * @param  {[type]} data       数据源
 * @return {[type]}            结构化后数据
 */
export function filterParams (paramsKeys, data) {
  const copyParamsKeys = cloneDeep(paramsKeys)
  const ret = copyParamsKeys.reduce((params, item) => {
    // 单纯的字段摘取
    if (typeof item === 'string') {
      params[item] = data[item]
      return params
    }
    // 参数结构化函数
    if (item.format) {
      params[item.newKey || item.key] = item.format(data[item.key], data)
      return params
    }
    // 参数默认值
    if (item.default) {
      params[item.newKey || item.key] = item.default
      return params
    }
    return params
  }, {})
  return ret
}
